<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>   
    <template v-slot:right_view>
      <ServiceProfileList></ServiceProfileList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import ServiceProfileList from '../../components/nsmfconfig/serviceProfile/ServiceProfileList';

export default {
  name: 'ServiceProfilePage',
  components: {
    BasicLayout,
    ServiceProfileList
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('NSMF.nsmfManage')}/${this.$t('NSMF.serviceProfile')}`
      }
    };
  }
};
</script>